import React, { FC } from 'react';
import { InfiniteData } from 'react-query';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { useRouter } from 'next/router';
import { getToysSortQuery, PageQueries } from '@specs/navigation';
import { useGetPrivateToysInfinity } from '@hooks/TRPC_Hooks/useGetToys';
import { InfiniteListType, profile } from '@specs/specs';
import { EmptyProfile } from '@components/Pages/ProfilePages/EmptyProfile/EmptyProfile';
import { CreateToyDraftCard } from '@components/Cards/CreateToyDraftCard/CreateToyDraftCard';
import { useGetDraftsInfinity } from '@services/toys/hooks/useGetDrafts';
import { toyDraft } from '@prisma/client';
import { LightCatalogView } from '@specs/views';
import { ToyDraftCard } from '@components/Cards/ToyDraftCard/ToyDraftCard';
import { InfinityMultiList } from '@components/InfinityList/InfinityMultiList';
interface Props {
  shortid: profile['shortid'];
}
const defaultInfinityItem: InfiniteData<InfiniteListType<toyDraft | LightCatalogView>> = {
  pages: [{
    items: [],
    nextCursor: undefined
  }],
  pageParams: []
};
const limit = 10;

// @ts-ignore
const isDraft = (item: toyDraft | LightCatalogView): item is toyDraft => item.hasOwnProperty('status') && typeof item?.status !== 'undefined';
export const MyGrid: FC<Props> = ({
  shortid
}) => {
  const router = useRouter();
  const {
    query,
    profilePageFilter,
    toysSort
  }: PageQueries = router.query;
  const sort = getToysSortQuery(toysSort);
  const isAll = typeof profilePageFilter === 'undefined' || profilePageFilter === 'all';
  const isUnderModeration = profilePageFilter === 'under_moderation';
  const isCreated = profilePageFilter === 'created';
  const isCollected = profilePageFilter === 'collected';
  const isOnSale = profilePageFilter === 'on_sale';
  const isEnabledNotExported = isAll || isUnderModeration;
  const {
    data: notExportedDrafts,
    fetchNextPage: notExportedFetch,
    hasNextPage: notExportedHasNextPage,
    isFetchingNextPage: notExportedIsFetchingNextPage,
    status: notExportedStatus
  } = useGetDraftsInfinity({
    limit,
    query,
    sort,
    excludedStatus: 'EXPORTED'
  }, {
    enabled: isEnabledNotExported
  });
  const isEnabledExported = isAll && notExportedHasNextPage === false || isCreated;
  const {
    data: exportedDrafts,
    fetchNextPage: exportedFetch,
    hasNextPage: exportedDraftsHasNextPage,
    isFetchingNextPage: exportedIsFetchingNextPage,
    status: exportedStatus
  } = useGetDraftsInfinity({
    limit,
    query,
    sort,
    includedStatus: 'EXPORTED'
  }, {
    enabled: isEnabledExported
  });
  const isEnabledToysInCollection = isAll && exportedDraftsHasNextPage === false || isCollected || isOnSale;
  const {
    data: toysInCollection,
    fetchNextPage: toysFetch,
    hasNextPage: toysHasNextPage,
    isFetchingNextPage: toysFetchNextPage,
    status: toysStatus
  } = useGetPrivateToysInfinity({
    limit,
    query,
    sort,
    user: {
      shortid,
      onSale: isOnSale
    }
  }, {
    enabled: isEnabledToysInCollection
  });
  const status = isEnabledToysInCollection ? toysStatus : isEnabledExported ? exportedStatus : notExportedStatus;
  const hasNextPage = isAll ? notExportedHasNextPage || exportedDraftsHasNextPage || toysHasNextPage : isUnderModeration ? notExportedHasNextPage : isCreated ? exportedDraftsHasNextPage : isCollected || isOnSale ? toysHasNextPage : false;
  const isFetchingNextPage = isAll ? notExportedIsFetchingNextPage || exportedIsFetchingNextPage || toysFetchNextPage : isUnderModeration ? notExportedIsFetchingNextPage : isCreated ? exportedIsFetchingNextPage : isCollected || isOnSale ? toysFetchNextPage : false;
  const data = [isEnabledNotExported && typeof notExportedDrafts !== 'undefined' ? notExportedDrafts : defaultInfinityItem, isEnabledExported && typeof exportedDrafts !== 'undefined' ? exportedDrafts : defaultInfinityItem, isEnabledToysInCollection && typeof toysInCollection !== 'undefined' ? toysInCollection : defaultInfinityItem] satisfies Array<InfiniteData<InfiniteListType<toyDraft | LightCatalogView>>>;
  const fetchNext = () => {
    if (isAll) {
      notExportedHasNextPage ? notExportedFetch() : exportedDraftsHasNextPage ? exportedFetch() : toysHasNextPage ? toysFetch() : undefined;
      return;
    }
    if (isUnderModeration && notExportedHasNextPage) {
      notExportedFetch();
      return;
    }
    if (isCreated && exportedDraftsHasNextPage) {
      exportedFetch();
      return;
    }
    if ((isCollected || isOnSale) && toysHasNextPage) {
      toysFetch();
      return;
    }
  };
  return <InfinityMultiList enabledRef={undefined} data={data} fetchNextPage={fetchNext} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} status={status} listClassName={'_toysGrid'} EmptyComponent={() => <EmptyProfile isMyProfile={true} pageType={'toys'} />} staticItemBeforeList={<CreateToyDraftCard />} data-sentry-element="InfinityMultiList" data-sentry-component="MyGrid" data-sentry-source-file="MyGrid.tsx">
            {item => {
      if (isDraft(item)) return <ToyDraftCard key={item.id + item.status} {...item} />;
      return <ToyCard key={item.id} {...item} />;
    }}
        </InfinityMultiList>;
};